import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Table from "react-bootstrap/Table";
import SideBar from "./SideBar";
import { loader } from "../redux/type";
import { registerNewUser } from "../Services/getServices";
import { pincodeList } from "../Services/getServices";
import { localityList } from "../Services/getServices";
import { districtList } from "../Services/getServices";
import { domainList } from "../Services/getServices";
import { LoginUser } from "../Services/authServices";
import { toast } from "react-toastify";
import { auth } from "../redux/type";
import { FaBars, FaHome, FaLock, FaMoneyBill, FaUser } from "react-icons/fa";
import { verifyLoginOtp } from "../Services/postServices";

const SelectCitizenUser = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mobNum = useLocation().state?.mobNo;
  const otp = useLocation().state?.otp;
   const userDetail = useLocation().state?.userDetail;
   console.log("DEKHO AAYA KYA=",userDetail);
   const [userId2,setUserId2]=useState(null);
   const [showbutton,setShowbutton]=useState("0");

   const [userDetails2,setUserDetails2]=useState([]);

   const manageUser=(ind)=>{
    // e.preventDefault() ;

    // console.log("INDEX=",e.target.value);

    console.log("INDEX=",ind);
    setUserId2(userDetail[ind]?.userName);
    setUserDetails2(userDetail[ind]);
    setShowbutton("2");

   }

    const loginThroughOtp=(e)=> {
       e.preventDefault() 

       if(userId2!==null){
   
       dispatch({ type: loader.startLoader });
   
       verifyLoginOtp(mobNum, otp,userId2, (res) => {
   
         dispatch({ type: loader.stopLoader });
         if (res?.data?.status) {
           toast.success(res?.data?.message);
   
           if (
             res?.data?.userdetail?.domainCodesByUserId[0]?.userTypeName === "N/A"
           ) {
             localStorage.setItem("userType", 0);
             localStorage.setItem("token", res?.data?.token);
   
             dispatch({
               type: auth.login,
               payload: res?.data?.userdetail,
             });
             navigate("/citizendashboard");
             window.location.reload();
           } else {
             toast.error("Login With DDA Official");
           }
         } else {
           toast.error(res?.message);
         }
   
       });

      }
      else{
        navigate("/myProfileRegister", { state: { mobNo: mobNum,userData: userDetails2} });
      }
     }

  return (
    <>
      <div className="card shadow myprofileCard ">
        <div className="card-body overFlow p-md-3">
          {/* <h4 className="h2_heading"> Select User</h4> */}

          
          {/* <div className="row">


{userDetail?.map((val,index)=>(
  <div className="card marTop shadow cardDash1 ">
  <div className="card-body"  onClick={() => {
      manageUser(index);
    }}>
 
    <FaUser
      className="iconSize2 mt-3"
     
    />

    <h5 style={{ color: "black" }}>

      {userDetail[index]?.fullName}
      
       
    </h5>
    <b>
    Domain:-{userDetail[index]?.domainCode}
     
      </b>
  
  </div>
  </div>


))}
</div> */}


<h5>Existing User List</h5>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th> Mobile No.</th>
                    
                  
                    <th>Applicaton Name</th>
                    <th>SSO User Id</th>
                    <th>Select</th>
                  </tr>
                </thead>
                <tbody>
                  {userDetail?.map((val, index) => (
                    <tr key={index}>
                      <td>{userDetail[index]?.fullName} </td>
                      <td>{userDetail[index]?.mobileNumber}</td>
                      <td>{userDetail[index]?.domainCode}</td>
                      <td>{userDetail[index]?.userName===null?<></>:<>{userDetail[index]?.userName}</>}</td>
                      <td>  <input
                type="radio"
              
                onClick={() => {
                  manageUser(index);
                }}
                name="Dda"
               
                className="marLeft"
              /> </td>
                    
                    </tr>
                  ))}
                </tbody>
              </Table>
            
            {showbutton==="2"?<>
              <div className="row justify-content-around ">
            <div className="col-2">
              <div className="form-outline mb-3">
                

                <button
                  type="btn"
                  className="btn btn-primary "
                 onClick={loginThroughOtp}
                >
                  Procced
                </button>
              
              </div>
            </div>
          </div>   

            </>:<></>}

          


          <Link to="/myprofile"><u>Create a new account</u></Link>
            

        </div>
      </div>
    </>
  );
};
export default SelectCitizenUser;
